import { render, staticRenderFns } from "./wx-menu-button-editor.vue?vue&type=template&id=4b93e591"
import script from "./wx-menu-button-editor.vue?vue&type=script&lang=js"
export * from "./wx-menu-button-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports